.title {
  padding-bottom: 24px;
}

.content {
  margin: 0 16px;
}

.container {
  margin: 24px;
}

.accessibilityError {
  margin: 16px 0 0 16px;
}

.accessibilityErrorDescription {
  list-style-type: disc;
  margin: 0 16px 16px 24px;
}

.contactInfo {
  margin-bottom: 4px;
}

@media (max-width: 768px) {
  .title {
    font-size: 1.2rem;
  }

  .content {
    margin: 0 8px;

    & p li {
      font-size: 0.9rem;
    }

    & h2 {
      font-size: 1.2rem;
    }

    & h3 {
      font-size: 1rem;
    }
  }
}
